import React from 'react';
import { Modal } from 'react-bootstrap';
import { Card, Button } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';

const DeleteInvoiceModal = ({ _this }) => {
  return (
    <Modal
      style={{ zIndex: 9999 }}
      show={_this.deleteInvoiceModalVisibility}
      onHide={() => _this.setDeleteInvoiceModalVisibility(false)}
      fullscreen="lg-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Alert</Modal.Title>
        <AiFillCloseCircle size={30} onClick={() => _this.setDeleteInvoiceModalVisibility(false)} />
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-3 flex  mr-2">
          <h3 className="text-font-label text-lg">
            Are You sure you want to delete{' '}
            <span className="text-black">{_this.deleteInvoiceId}</span> this invoice.
          </h3>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button color="danger" onClick={() => _this.handleDeleteInvoiceSubmit()}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteInvoiceModal;
